import React, { Fragment } from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import Avatar from '@atlaskit/avatar';

import IssueIcon from '@atlaskit/icon/core/issue';
import QuotationMarkIcon from '@atlaskit/icon/core/quotation-mark';
import WhiteboardIcon from '@atlaskit/icon/core/whiteboard';
import FolderClosedIcon from '@atlaskit/icon/core/folder-closed';
import CommentIcon from '@atlaskit/icon/core/comment';
import DatabaseIcon from '@atlaskit/icon/core/database';

import PageIcon from '@atlaskit/icon/core/page';
import { AttachmentIcon } from '@atlassian/search-common';
import { IconTile } from '@atlaskit/icon';

type ContentIconRendererArgs = {
	type: string;
	title?: string | null | undefined;
	iconCssClass?: string;
	imageSrc?: string;
	isDraft?: boolean;
};

type GenericIconRendererArgs = {
	iconUrl: string;
	size?: 'small' | 'xsmall';
	appearance?: 'square' | 'circle';
};

const negativeMarginStyles = xcss({
	margin: 'space.negative.025',
	display: 'flex',
});

const SIZE = '24';
const SHAPE = 'square';

// TODO: Figure out type for smartlinks
export const ContentIconRenderer = ({
	type,
	imageSrc,
	title,
	isDraft = false,
}: ContentIconRendererArgs) => {
	// CONFLUENCE
	if (type === 'page' || type === 'confluence-page' || type === 'content') {
		return (
			<IconTile
				icon={PageIcon}
				label={type}
				appearance={isDraft ? 'gray' : 'blue'}
				shape={SHAPE}
				size={SIZE}
			/>
		);
	} else if (type === 'blogpost' || type === 'confluence-blogpost') {
		return (
			<IconTile
				icon={QuotationMarkIcon}
				label={type}
				appearance={'blue'}
				shape={SHAPE}
				size={SIZE}
			/>
		);
	} else if (type === 'database') {
		return (
			<IconTile icon={DatabaseIcon} label={type} appearance={'purple'} shape={SHAPE} size={SIZE} />
		);
	} else if (type === 'folder') {
		return (
			<IconTile
				icon={FolderClosedIcon}
				label={type}
				appearance={'blue'}
				shape={SHAPE}
				size={SIZE}
			/>
		);
	} else if (type === 'whiteboard') {
		return (
			<IconTile icon={WhiteboardIcon} label={type} appearance={'teal'} shape={SHAPE} size={SIZE} />
		);
	} else if (type === 'comment') {
		return (
			<IconTile icon={CommentIcon} label={type} appearance={'yellow'} shape={SHAPE} size={SIZE} />
		);
	} else if (type === 'attachment') {
		// TODO: Clarify if the attachment icon should be changed
		return <AttachmentIcon title={title || ''} size="medium" label={type} />;
	} else if (type === 'atlas') {
		return <img width="24px" height="24px" src={imageSrc || ''} aria-label={type} alt={type} />;
	} else if (type === 'jira') {
		// TODO: Clarify the decision made for jira icons
		return <IconTile icon={IssueIcon} label={type} appearance={'blue'} shape={SHAPE} size={SIZE} />;
	}
	return <Fragment />;
};

export const GenericIconRenderer = ({
	iconUrl,
	size = 'small',
	appearance = 'square',
}: GenericIconRendererArgs) => (
	<Box xcss={negativeMarginStyles}>
		<Avatar
			size={size}
			borderColor="transparent"
			src={iconUrl}
			appearance={appearance}
			testId="result-avatar"
		/>
	</Box>
);
